/**
 * @author Matěj Grabovský <matej.grabovsky@ki-wi.cz>
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import ErrorName from '../../../../core/error/error-name';

/**
 * Triviální správce souborových archivů pro webovou platformu.
 * @implements {FileArchiveManager}
 * @memberof AdapterWeb
 */
class FileArchiveManager {
  /** @inheritdoc */
  getVolume(path) {
    return new Promise(() => {
      const error = new Error('No entry exists.');
      error.name = ErrorName.NotFoundError;
      throw error;
    });
  }
}

export default FileArchiveManager;
